export default __webpack_public_path__ + "static/media/lato-regular.4fbf7015.ttf";